export default class DeviceService {
    static get $inject() {
        return [
            '$http', 'ApiService'
        ];
    }

    CONPROTO_DECT = 'D';
    CONPROTO_RADIO = 'R';

    static get deviceTypes() {
        return {
            0x31: {
                name: "SDEVTYPE_PIR",
                is_zone: true,
            }, // Infrared motion detector
            0x32: {
                name: "SDEVTYPE_MAG",
                is_zone: true,
            }, // Magnetic contact
            0x33: {
                name: "SDEVTYPE_RMT",
                is_zone: true,
            }, // Pendant remote control
            0x34: {
                name: "SDEVTYPE_SMK",
                is_zone: true,
                always_on: true,
            }, // Smoke detector
            0x35: {
                name: "SDEVTYPE_GAS",
                is_zone: true,
                always_on: true,
            }, // Gas detector
            0x36: {
                name: "SDEVTYPE_GBD",
                is_zone: true,
            }, // Glass break detector
            0x37: {
                name: "SDEVTYPE_CAM",
                is_zone: true,
            }, // Camera PIR
            0x38: {
                name: "SDEVTYPE_FLD",
                is_zone: true,
                always_on: true,
            }, // Flood detector
            0x39: {
                name: "SDEVTYPE_VIB",
                is_zone: true,
            }, // Vibration sensor
            0x3A: {
                name: "SDEVTYPE_HAM",
                is_zone: false,
            }, // Home automation
            0x3B: {
                name: "SDEVTYPE_SPO",
                is_zone: true,
            }, // Heart & saturation monitor
            0x3C: {
                name: "SDEVTYPE_TFM",
                is_zone: true,
            }, // Temperature-flood-magnet detector
            0x45: {
                name: "SDEVTYPE_SRN",
                is_zone: false,
            }, // Siren
            0x57: {
                name: "SDEVTYPE_OUT",
                is_zone: false,
            }, // Output (relay board)
            0x98: {
                name: "SDEVTYPE_KPD",
                is_zone: false,
            }, // Keypad
            0xE7: {
                name: "SDEVTYPE_SOC",
                is_zone: false,
            }, // Keypad
        }
    }

    constructor($http, ApiService) {
        this.$http = $http;
        this.api = ApiService._api;
    }

    getDeviceTypeObject(deviceTypeInt) {
        return DeviceService.deviceTypes[deviceTypeInt * 1] || 'unknown';
    }

    createDevice(panelId, data) {
        return this.$http.post(this.api + '/wizard/' + panelId + '/devices/', data);
    }

    getDevicesStatus(panelId) {
        return this.$http.get(this.api + '/wizard/' + panelId + '/status/')
            .then(resp => resp.data);
    }

    cleanDevicesStatus(panelId) {
        return this.$http.delete(this.api + '/wizard/' + panelId + '/status/')
            .then(resp => resp.data);
    }

    getDevices(panelId) {
        return this.$http.get(this.api + '/wizard/' + panelId + '/devices/')
            .then(resp => resp.data);
    }


    static _getIpud(device_id) {
        let ipud = device_id.replace(/:/g, '').toLowerCase();
        if (ipud.length > 10) {
            ipud = ipud.substr(0, 10);
        }
        return ipud;
    }

    checkDeviceUnknown(panelId, connect_type, device_id) {
        device_id = connect_type == this.CONPROTO_DECT ? DeviceService._getIpud(device_id) : parseInt(device_id);
        return this.getDevices(panelId)
            .then(zones => {
                return !~_.findIndex(zones, z => {
                    if (connect_type == this.CONPROTO_DECT) {
                        return z.dect_id && z.dect_id.ipud && DeviceService._getIpud(_.get(z, 'dect_id.ipud', '')) === device_id;
                    }
                    return z.device_id === device_id;
                });
            });
    }

    startDectPairing(panelId) {
        return this.$http.post(this.api + '/wizard/' + panelId + '/dect/')
            .then(resp => resp.data);
    }

    getDectPairingStatus(panelId, waitForState) {
        let url = `${this.api}/panels/${panelId}/dect/learn_state/`;
        if (waitForState) {
            url = url + `${waitForState}/`;
        }
        return this.$http.get(url)
            .then(resp => resp.data);
    }

    getDectList(panelId) {
        return this.$http.get(this.api + '/panels/' + panelId + '/dect/')
            .then(resp => resp.data);
    }

    checkDectPaired(panelId, ipud) {
        return this.getDectList(panelId)
            .then(list => {
                return ~_.findIndex(list, item => DeviceService._getIpud(item.ipud) == DeviceService._getIpud(ipud));
            });
    }
}


/** WEBPACK FOOTER **
 ** ./src/main/panels/panel/services/device.service.js
 **/